import { Mirror } from "../stores";
import { MyEventEmitter } from "./EventEmitter";
import { createClient } from "graphql-ws";
const wsHouseBetsQuery = {
    query: `
        subscription HouseBets {
            houseBets {
                ...RealtimeHouseBet
                __typename
            }
        }

        fragment RealtimeHouseBet on Bet {
            id
            iid
            game {
                name
            }
            bet {
                __typename
                ... on CasinoBet {
                    id
                    active
                    payoutMultiplier
                    amountMultiplier
                    amount
                    payout
                    
                    updatedAt
                    currency
                    state {
                
                    
                           ... on CasinoGameDice { 
                                result
                                target
                                condition
                            }
                           ... on CasinoGameLimbo { 
                                result
                                multiplierTarget
                    
                            }
                           ... on CasinoGamePlinko {
                              rows
                              riskPlinko: risk
                           }
                           ... on CasinoGamePacks {
                             cards {
                                id
                                multiplier
                              }
                           }
                            ... on CasinoGameKeno {
                              drawnNumbers
                              selectedNumbers
                              riskKeno: risk
                            }
                           ... on  CasinoGameDiamonds {  hand }
    
                           ... on  CasinoGameHilo {
                            startCard {
                              suit
                              rank
                            }
                            roundsHilo: rounds {
                              card {
                                suit
                                rank
                              }
                              guess
                              payoutMultiplier
                            }
                          }  
                          
                          ... on CasinoGameSlots {
                            lines
                            rounds {
                              scatterMultiplier
                              roundMultiplier
                              totalMultiplier
                              bonusRemaining
                              bonusTotal
                            }
                          }
                        
                    }
                    __typename
                }	
                				
            }
           
        }
    `,
    variables: {}
}

let mirror
Mirror.subscribe( ($val) => { mirror = $val })

const api_ws = "wss://stake.com/_api/websockets"; // "wss://stake.games/_api/websockets";
const api_ws_proxy = "ws://127.0.0.1:3002/ws1"
let gqlws

const gqlws_createClient = async (config = {}) => {

    const emitter = new MyEventEmitter

    const _api_ws =`wss://stake.${mirror}/_api/websockets`          

    const c = await createClient({
        url: _api_ws, // api_ws_proxy
        connectionParams: config.connectionParams || {},
        lazy: false,
        retryAttempts: 2,
        // keepAlive: 25_000,
        on: {
            connected: (WebSocket, initResponse) => {
                /* console.log("graph-ql client connected, response ", WebSocket)*/


            },
        },
        onNonLazyError: (err) => {
            console.error("graph-ql client onNonLazyError", err)
            emitter.emit("gqlws error", err)
        }
    })


    let _subs = [];
    const wsSubscribe = (payload, onNext = () => { }) => {

        const _onNext = (data) => {
            /* handle incoming values */
            if (typeof onNext === "function") onNext(data);
        };

        let _unsubscribe
        const unsubscribe = () => {
            /* complete the subscription */
            return (typeof _unsubscribe === 'function') ? _unsubscribe() : _unsubscribe
        };

        new Promise((resolve, reject) => {
            _unsubscribe = c.subscribe(
                {
                    query: `${payload.query}`,
                    variables: payload.variables || {},
                },
                {
                    next: _onNext,
                    error: reject,
                    complete: resolve,
                }
            );
            _subs.push(unsubscribe)
        });

        return unsubscribe
    };


    const wsQuery = async (payload) => {
        try {
            /*
                const result = await new Promise((resolve, reject) => {
                    let result;
                    c.subscribe(
                        {
                            query: `${payload.query}`,
                            variables: payload.variables || {},
                        },
                        {
                            next: (data) => (result = data),
                            error: reject,
                            complete: () => resolve(result),
                        }
                    );
                });
                return result;
                */
            if (window?.TM?.StakeApi) {
                let result = await window?.TM?.StakeApi("com", {
                    headers: {
                        "x-access-token": config.connectionParams.accessToken,
                    }
                },
                    {
                        query: `${payload.query}`,
                        variables: payload.variables || {},
                    })

                return result.response

            }
            else {
                const req = await fetch(`https://stake.${mirror}/_api/graphql`, {
                    method: "POST",
                    body: JSON.stringify({
                        query: `${payload.query}`,
                        variables: payload.variables || {},
                    }),
                    headers: {
                        "content-type": "application/json",
                        "x-access-token": config.connectionParams.accessToken,
                    }
                })

                if (req.status === 200) {
                    return await req.json()
                }
            }


            return {}

        }
        catch (err) {
            console.error("gqlws.wsQuery error. ", err)
            // throw err
        }
    };



    return { ...c, emitter, wsQuery, wsSubscribe, subscriptions: _subs };
};



export const _createStakeWsClient = async (apikey) => {
    console.log("create StakeWsClient...")
    const client = await gqlws_createClient({ connectionParams: { accessToken: apikey, language: "en" } });
    console.log("client ", client)
    //const receiverClient = gqlws_createClient();

    /*
        let result
        
        result = await client.wsQuery({
            query: "query user { user { id name __typename } }",
        })
    
        console.log("user data: ", result.data )
    
    */


    return { ...client };
};

/********/

async function reset() {
    if (gqlws)
        gqlws.dispose()

    gqlws = await StakeWsClient();
    console.log(gqlws);
    //list = []

}